export const LOGIN = '/login-20/login'
export const OAUTH = '/oauth-20/'
export const LINK_CHAMP = '/champ/link'
export const INFO = '/info/'
export const MAIL_REGISTRATION = '/login-20/mail-registration'

export const REGISTRATION = '/account/registration'
export const EXT_REGISTRATION = '/account/external-registration'
export const UNBLOCK = '/account/unblock'
export const RECOVERY = '/account/recovery'
export const RECOVERY_PROFILE = '/account/recovery-profile'
export const ADD_EMAIL = '/account/add-email'
export const ADD_PHONE = '/account/add-phone'

export const ADD_PHONE_ACCOUNT = '/account/add-phone-account'
export const ADD_EMAIL_ACCOUNT = '/account/add-email-account'

export const PROFILE = '/account/profile'
export const DEFAULT_CHAMP = '/account/default-champ'

export const APPLICATIONS = '/account/applications'
export const DELETE_MAIL = '/account/delete-mail'
export const DELETE_ACCOUNT = '/account/delete-account'
export const DELETE_PROFILE = '/account/delete-profile'

export const SESSION = '/account/session'
export const ACTIVE = '/account/session/active'
export const HISTORY = '/account/session/history'

export const TWO_FACTOR_AUTHN = '/account/two-factor-authn'

export const CHANGE_PASSWORD = '/account/change-password'
export const CHANGE_QUESTION = '/account/change-question'
export const CHANGE_PHONE = '/account/change-phone'
